import { render } from "./LorealProjectTwo.vue?vue&type=template&id=6a0b8d38&scoped=true"
import script from "./LorealProjectTwo.vue?vue&type=script&lang=js"
export * from "./LorealProjectTwo.vue?vue&type=script&lang=js"

import "./LorealProjectTwo.vue?vue&type=style&index=0&id=6a0b8d38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0b8d38"]])

export default __exports__